﻿// this code is first to detect and apply the color scheme as quickly as possible.

const matchedScheme = window.matchMedia("(prefers-color-scheme: dark)");
window.matchedScheme = matchedScheme;

const SCHEME_AUTO = "AUTO";
const SCHEME_DARK = "DARK";
const SCHEME_LIGHT = "LIGHT";

window.SCHEME_AUTO = SCHEME_AUTO;
window.SCHEME_DARK = SCHEME_DARK;
window.SCHEME_LIGHT = SCHEME_LIGHT;

let KEY_SCHEME = "SCHEME";
window.KEY_SCHEME = KEY_SCHEME;

const data = {};
window.cb_hasLocalStorage = false;

if (localStorage) {
    try {
        const x = 'detectStorageCapacity';
        localStorage.setItem(x, x);
        localStorage.removeItem(x);
        window.cb_hasLocalStorage = true;
    } catch (e) {
        window.cb_hasLocalStorage = false;
    }
}

function getSchemePreference() {
    if (window.cb_hasLocalStorage) {
        const pref = window.localStorage.getItem(window.KEY_SCHEME);
        if (pref == SCHEME_DARK || pref == SCHEME_LIGHT) {
            return pref;
        }
    }
    return SCHEME_AUTO;
}

function isAutoSchemeDark() {
    const isDark = matchedScheme.matches;
    return isDark;
}

function getEffectiveScheme() {
    const pref = getSchemePreference();
    if (pref == SCHEME_AUTO) {
        const isDark = matchedScheme.matches;
        return [true, (isDark ? SCHEME_DARK : SCHEME_LIGHT)];
    }
    return [false, pref];
}
window.getEffectiveScheme = getEffectiveScheme;

function setSchemePreference(pref) {
    if (window.cb_hasLocalStorage) {
        window.localStorage.setItem(window.KEY_SCHEME, pref);
    }
}
window.setSchemePreference = setSchemePreference;

function syncEffectiveScheme() {
    const effectiveScheme = getEffectiveScheme();

    if (effectiveScheme[1] == SCHEME_DARK) {
        document.body.classList.add('dark-scheme');
        document.body.classList.remove('light-scheme');
    } else {
        document.body.classList.remove('dark-scheme');
        document.body.classList.add('light-scheme');
    }
}
syncEffectiveScheme();
window.syncEffectiveScheme = syncEffectiveScheme;